'use client';

import FormText from '@/components/form/FormText/FormText';
import FaIcon, { faSearch } from '@/components/icon/FaIcon/FaIcon';
import { useRouter } from 'next/navigation';
import { useForm } from 'react-hook-form';
import styles from './ECommerceTopTextSearchForm.module.scss';

function ECommerceTopTextSearchForm() {
  const router = useRouter();
  const { handleSubmit, control, getValues } = useForm({
    mode: 'onChange',
    defaultValues: {
      searchText: '',
    },
  });

  const goCreatorList = () => {
    router.push(`/e-commerce/biz-team-creator?q=${getValues('searchText')}`);
  };

  const onChangeText = () => {
    goCreatorList();
  };

  const submitText = async () => {
    goCreatorList();
  };

  return (
    <>
      <div className={styles.header}>
        <div className={styles.textSearchWrapper}>
          <form onSubmit={handleSubmit(submitText)}>
            <FormText
              name='searchText'
              control={control}
              outlined
              placeholder={'グループ名・アーティスト名を検索できます'}
              prefix={
                <div className={styles.searchIcon}>
                  <FaIcon icon={faSearch} size='xl' />
                </div>
              }
              onChange={onChangeText}
              isSmall={true}
            ></FormText>
          </form>
        </div>
      </div>
    </>
  );
}

export default ECommerceTopTextSearchForm;
